module.exports = __webpack_public_path__ + "static/media/image-super-auto.83c90b3f.svg";